export default function updateMigrationStatusReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_MIGRATION_STATUS_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_MIGRATION_STATUS_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_MIGRATION_STATUS_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}